import Vue from "vue";
import App from "./App.vue";
import "./index.css";
import router from "./router";
import AppHeader from "./components/Header.vue";
import AppFooter from "./components/Footer.vue";
import VueCarousel from 'vue-carousel';

Vue.config.productionTip = false;
Vue.component("app-header", AppHeader);
Vue.component("app-footer", AppFooter);
Vue.use(VueCarousel);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
